function formatGroupageDate(dateExpedition?: string): string | null {
  if (!dateExpedition) return null;

  const date = new Date(dateExpedition);
  if (Number.isNaN(date.getTime())) return null;

  return new Intl.DateTimeFormat("fr-FR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function getCarrierMessage(
  isGroupage = false,
  dateExpedition?: string,
  transporteur?: string,
): string {
  const configTitle = "Efashion Paris";

  if (isGroupage) {
    const formattedDate = formatGroupageDate(dateExpedition);
    const dateLine = formattedDate
      ? ` Les colis doivent impérativement être remis à la date de groupage : le <strong>${formattedDate}</strong>.`
      : "";

    return `<p style="font-size: 12px; line-height: 1.4; color: black;">
    Bonjour, <br/><br/>
    Veuillez remettre les colis au <strong style="color: #E53E3E;">chauffeur Easy Express</strong> si vous êtes situés à Aubervilliers.
    Dans le cas contraire, veuillez les remettre au chauffeur Efashion.${dateLine}<br/><br/>
    Merci à vous, <br/>
    L'équipe ${configTitle}
</p>`;
  }

  const transporteurLine = transporteur
    ? ` ou au transporteur ${transporteur}`
    : "";

  return `<p style="font-size: 12px; line-height: 1.4; color: black;">
    Bonjour, <br/><br/>
    Veuillez remettre les colis au chauffeur Easy Express si vous êtes situés à Aubervilliers.
    Dans le cas contraire, veuillez les remettre au chauffeur Efashion${transporteurLine}.<br/><br/>
    Merci à vous, <br/>
    L'équipe ${configTitle}
</p>`;
}
